var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`card-col ${_vm.currentSort.col === _vm.active.col ? 'active' : ''} ${
      _vm.currentSort.dir
    }`,on:{"click":function($event){return _vm.changeSort(_vm.column)}}},[_c('span',{class:{ small: _vm.smallerText }},[_vm._v(_vm._s(this.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }